/**
 * Front end filtering for Raw data repository data set files
 * The filters are not fully implemented, and will be replaced with a back end filter in the future.
 */

export let FileNameFilter = class {
  constructor(fileNameFragment) {
    this.fileNameFragment = fileNameFragment
  }
  filterType() { return 'file-name' }
  toString() { return this.fileNameFragment }
  equals(fileNameFilter) {
    if (fileNameFilter.filterType() != this.filterType()) {
      return false
    }
    return this.value == fileNameFilter.value
  }
  get value() { return this.fileNameFragment }
}
export let StationCategoryFilter = class {
  constructor(stationCategory) {
    this.category = stationCategory
  }
  filterType() { return 'station-category' }
  toString() {
    return this.category
  }
  equals(stationCategoryFilter) {
    if (stationCategoryFilter.filterType() != this.filterType()) {
      return false
    }
    return this.category == stationCategoryFilter.category
  }
  get value() {
    return this.category
  }
}

export let LocationFilter = class {
  constructor(location) {
    this.location = location
  }
  filterType() { return 'location' }
  toString() {
    return this.location
  }
  equals(locationFilter) {
    if (locationFilter.filterType() != this.filterType()) {
      return false
    }
    return this.location == locationFilter.location
  }
  get value() {
    return this.location
  }
}

export let TimeFilter = class {
  constructor(timeStart, timeEnd) {
    this.timeStart = timeStart
    this.timeEnd = timeEnd
  }

  filterType() { return 'time' }
  toString() {
    if (this.timeStart == null && this.timeStart == null) return null
    let start = this.timeStart == null ? '' : `${this.timeStart.toISOString().slice(0, 10)} < `
    let end = this.timeEnd == null ? '' : ` < ${this.timeEnd.toISOString().slice(0, 10)}`
    return `${start}t${end}`
  }
  equals(timeFilter) {
    if (timeFilter.filterType() != this.filterType()) {
      return false
    }
    return ((this.timeStart == timeFilter.timeStart) && (this.timeEnd == timeFilter.timeEnd))
  }
  get value() {
    if (this.timeStart == null && this.timeEnd == null) return null
    return { start: this.timeStart, end: this.timeEnd }
  }
}

export let MetadataMatchValuesFilter = class {
  constructor(key, type, value) {
    this.fieldName = key
    this.fieldType = type
    this.fieldValues = Array.isArray(value) ? value : [value]
  }
  filterType() { return 'metadata-match-values' }
  toString() {
    return `Key: ${this.fieldName}, Type: ${this.fieldType}, Value: ${this.fieldValues}`
  }
  equals(metadataFilter) {
    if (metadataFilter.filterType() != this.filterType()) {
      return false
    }
    return ((this.fieldName == metadataFilter.fieldName) && (this.fieldType == metadataFilter.fieldType) && (this.fieldValues == metadataFilter.fieldValues))
  }
  get value() {
    return {
      Field: this.fieldName,
      FieldType: this.fieldType,
      FieldValues: this.fieldValues,
    }
  }
}

export let MetadataMatchRangeFilter = class {
  constructor(key, type, min, max) {
    this.fieldName = key
    this.fieldType = type
    this.fieldMinValue = min
    this.fieldMaxValue = max
  }
  filterType() { return 'metadata-match-range' }
  toString() {
    let valString = 'Value'
    if (this.fieldMinValue != null || this.fieldMinValue != '') {
      valString = `${this.fieldMinValue}<=${valString}`
    }
    if (this.fieldMaxValue != null || this.fieldMaxValue != '') {
      valString = `${valString}<=${this.fieldMaxValue}`
    }
    return `Key:${this.fieldName},Type:${this.fieldType},${valString}`
  }
  equals(filter) {
    if (filter.filterType() != this.filterType()) {
      return false
    }
    return (
      filter.fieldName == this.fieldName &&
      filter.fieldType == this.fieldType &&
      filter.fieldMinValue == this.fieldMinValue &&
      filter.fieldMaxValue == this.fieldMaxValue
    )
  }
  get value() {
    return {
      Field: this.fieldName,
      FieldType: this.fieldType,
      MinValue: this.fieldMinValue,
      MaxValue: this.fieldMaxValue,
    }
  }
}

export let InvalidMetadataFilter = class {
  constructor(isValid) {
    this.isValid = isValid
  }
  filterType() { return 'invalid-metadata' }
  toString() {
    return this.isValid ? 'Disabled' : 'Enabled'
  }
  equals(invalidMetadataFilter) {
    if (invalidMetadataFilter.filterType() == this.filterType()) {
      return false
    }
    return this.isValid == invalidMetadataFilter.isValid
  }
}